import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentUserId } from "./use-current-user";
import { useRole } from "@/contexts/RoleContext";

export function useUserLocation() {
  const { userRole } = useRole();
  const { data: userId } = useCurrentUserId();

  return useQuery({
    queryKey: ['user-location-name', userId, userRole],
    queryFn: async () => {
      if (!userId) return null;

      // For parents, get location from their students
      if (userRole === 'parent') {
        const { data: students } = await supabase
          .from('student_profiles')
          .select('location_id')
          .eq('parent_user_id', userId)
          .not('location_id', 'is', null)
          .limit(1);

        const locationId = students?.[0]?.location_id;
        if (!locationId) return null;

        const { data: location } = await supabase
          .from('locations')
          .select('name')
          .eq('id', locationId)
          .single();

        return location?.name || null;
      }

      // For staff (center_manager, tutor, admin), get from user_locations
      const { data: userLocations } = await supabase
        .from('user_locations')
        .select('location_id')
        .eq('user_id', userId)
        .limit(1);

      const locationId = userLocations?.[0]?.location_id;
      if (!locationId) return null;

      const { data: location } = await supabase
        .from('locations')
        .select('name')
        .eq('id', locationId)
        .single();

      return location?.name || null;
    },
    select: (value) => (typeof value === 'string' || value === null ? value : null),
    enabled: !!userId && !!userRole,
    staleTime: 10 * 60 * 1000,
  });
}
